import React, { Component } from 'react';
import { Container, Icon, Input, Form, Progress, Divider, Loader, Message, Grid, Button } from 'semantic-ui-react';
import Slider from 'rc-slider/lib/Slider';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Prompt, Link, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import actions from 'actions';
import { api } from 'api';

import RichTextViewer from 'components/includes/RichTextViewer';
import StroopTest from './StroopTest';
import Weight from './types/Weight';
import Height from './types/Height';
import Temperature from './types/Temperature';

class ParticipateStage extends Component {
  state = { responsesSaved: false, stage: null, loading: false, response: {}, stageUnderway: false, componentIndex: -1, hideNext: true, sliderValue: 0 }

  componentWillMount() {
    this.setState({ loading: true });
    api.participants.getTrialStage(this.props.trial?._id, this.props.match.params.stageId, stage => {
      this.setState({ stage, loading: false });
    }, err => toast.error(err.message));
  }

  startStage = () => {
    this.setState({ componentIndex: 0, stageUnderway: true });
  }
  finishStage = () => {
    this.props.history.push(`/`);
  }

  saveResponses = () => {
    const { participant, trial } = this.props;
    const { stage, response } = this.state;
    this.setState({ saving: true, saveError: null });
    api.trials.createResponse(trial._id, stage._id, response, () => {
      this.props.onStageCompleted(participant._id, stage._id);
      this.setState({ saving: false, responsesSaved: true, stageUnderway: false });
      toast.info(this.props.t('trial.stage.saved'));
    }, err => {
      //toast.error(err.message);
      this.setState({ saving: false, saveError: err.message || 'Unable to save the responses' });
    });
  }

  percentageComplete = () => {
    const { stage } = this.state;
    const total = stage && stage.components && stage.components.length;
    return (this.state.componentIndex * 100) / total;
  }
  isLastComponent = () => {
    const { stage } = this.state;
    const total = stage && stage.components && stage.components.length;
    return this.state.componentIndex >= total;
  }
  nextComponent = () => {
    if (!this.isLastComponent()) {
      const currentIndex = this.state.componentIndex;
      this.setState({ componentIndex: currentIndex + 1, hideNext: true, sliderValue: 0 }, () => {
        if (this.isLastComponent()) this.saveResponses();
      });
    }
  }
  updateResponse = data => {
    const { stage } = this.state;
    const response = Object.assign({}, this.state.response);
    const component = stage.components[this.state.componentIndex];
    response[component.type._id] = Object.assign({ createdAt: new Date() }, response[component.type._id], data);
    this.setState({ response, hideNext: false });
  }

  toggleChoiceOption = (o) => {
    const { stage } = this.state;
    const component = stage.components[this.state.componentIndex];
    const resp = Object.assign({}, this.state.response[component.type._id]);
    const value = Object.assign([], resp.value);
    const index = value.indexOf(o);
    if (index === -1) value.push(o);
    else value.splice(index, 1);
    this.updateResponse({ value });
  }
  startStroopTest = () => {
    window.scrollTo(0, 0)
    this.setState({ runStroopTest: true });
  }
  finishStroopTest = (results) => {
    this.setState({ runStroopTest: false });
    this.updateResponse({ value: results });
    this.nextComponent();
  }

  render() {
    const { t } = this.props;
    const { responsesSaved, stage, loading, response, componentIndex, runStroopTest, saving, saveError, hideNext, sliderValue } = this.state;
    const component = stage && stage.components[componentIndex];
    const currentResponse = component && response[component.type._id];
    return (
      <Container style={{marginTop: 40}} className='participant-view'>
        {loading && !stage && <Loader centered='inline' active />}
        <Prompt when={this.state.stageUnderway} message='Your responses are not saved. If you leave this page then you may not be able to complete the stage successfully. Click "cancel" to stay on the page.'/>
        {stage &&
          <Grid stackable centered>
            <Grid.Column computer={10} tablet={16}>
              {componentIndex === -1 &&
                <div>
                  <Link to='/' className='ui basic button'><Icon name='arrow left' /> {t('trial.stage.back')}</Link>
                  <h2>{stage.name}</h2>

                  {stage.description &&
                    <p className='break-lines'>{stage.description}</p>
                  }
                  <Divider section hidden/>
                  <Message size='large'>{t('trial.stage.progressToEnd')}</Message>
                  <Divider hidden />
                  <Button size='huge' color='teal' icon='rocket' fluid content={t('trial.stage.start')} onClick={this.startStage}/>
                </div>
              }

              {component &&
                <div>
                  {!runStroopTest &&
                    <div>
                      <Progress percent={this.percentageComplete()} active success />
                      <h2>{component.title}</h2>
                      <RichTextViewer content={component.description} />
                      <Divider section hidden/>

                      {component.type &&
                        <div>
                          {component.type.type === 'text' &&
                            <Input size='large' fluid onChange={e => this.updateResponse({ value: e.target.value })}/>
                          }
                          {component.type.type === 'paragraph' &&
                            <Form><Form.TextArea size='large' onChange={e => this.updateResponse({ value: e.target.value })}/></Form>
                          }
                          {component.type.type === 'integer' &&
                            <Input size='large' type='number' fluid onChange={e => this.updateResponse({ value: parseInt(e.target.value) })}/>
                          }
                          {component.type.type === 'float' &&
                            <Input size='large' type='number' fluid onChange={e => this.updateResponse({ value: parseFloat(e.target.value) })}/>
                          }
                          {component.type.type === 'slider' &&
                            <div style={{textAlign:'center'}}>
                              <p style={{fontSize: 30, marginBottom: 20}}>{sliderValue}</p>
                              <Slider value={sliderValue} min={component.minimum || 1} max={component.maximum || 10} steps={1} onChange={s => this.setState({ sliderValue: s })} onAfterChange={s => this.updateResponse({ value: s })}/>
                            </div>
                          }
                          {component.type.type === 'choice' &&
                            (component.type.multiple ?
                              <div>
                                {component.type.options && component.type.options.map(o =>
                                  <Button style={{marginBottom: 8}} size='large' fluid color='violet' basic={!(currentResponse && currentResponse.value && currentResponse.value.indexOf(o) > -1)} key={o} content={o} icon={currentResponse && currentResponse.value && currentResponse.value.indexOf(o) > -1 && 'check'} onClick={e => this.toggleChoiceOption(o)}/>
                                )}
                              </div>
                            :
                              <div>
                                {component.type.options && component.type.options.map(o =>
                                  <Button style={{marginBottom: 8}} size='large' fluid color='violet' basic={(currentResponse && currentResponse.value) !== o} key={o} content={o} icon={(currentResponse && currentResponse.value) === o && 'check'} onClick={e => this.updateResponse({ value: o })}/>
                                )}
                              </div>
                            )
                          }
                          {component.type.type === 'weight' &&
                            <Weight value={currentResponse} onUpdated={value => this.updateResponse({ value })}/>
                          }
                          {component.type.type === 'height' &&
                            <Height value={currentResponse} onUpdated={value => this.updateResponse({ value })}/>
                          }
                          {component.type.type === 'temperature' &&
                            <Temperature value={currentResponse} onUpdated={value => this.updateResponse({ value })}/>
                          }
                          {component.type.type === 'stroop' &&
                            (!currentResponse &&
                              <Button size='huge' color='violet' fluid onClick={this.startStroopTest}><Icon name='checkered flag' /> {t('trial.stage.stroop.ready')}</Button>
                            )
                          }
                        </div>
                      }
                    </div>
                  }

                  {runStroopTest &&
                    <StroopTest settings={component.type} stage={stage} onComplete={this.finishStroopTest} />
                  }

                  {currentResponse && !hideNext &&
                    <div>
                      <Divider section hidden />
                      <Button size='huge' color='teal' fluid onClick={this.nextComponent}><Icon name='chevron right' /> {t('trial.stage.nextComponent')}</Button>
                    </div>
                  }
                </div>
              }

              {this.isLastComponent() &&
                <div style={{textAlign: 'center'}}>
                  <Progress percent={this.percentageComplete()} active success />
                  <Divider hidden section />
                  <h2>{t('trial.stage.thanks.title')}</h2>
                  <Divider section hidden />
                  {saving && <Loader inline='centered' active />}
                  {saveError &&
                    <div>
                      <Message warning header={t('trial.stage.saveError')} content={saveError} />
                      <Button size='huge' color='teal' fluid disabled={saving} loading={saving} onClick={this.saveResponses} icon='refresh' content={t('trial.stage.saveAgain')} />
                    </div>
                  }
                  {responsesSaved &&
                    <div>
                      <p>{t('trial.stage.thanks.info')}</p>
                      <Message success header={t('trial.stage.saved')} />
                      <Button size='huge' color='teal' fluid disabled={saving} loading={saving} onClick={this.finishStage}><Icon name='check'/> {t('trial.stage.finish')}</Button>
                    </div>
                  }
                </div>
              }
            </Grid.Column>
          </Grid>
        }
      </Container>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { currentParticipantId } = state.participants;
  const participant = state.participants.participants.filter(p => p._id === currentParticipantId)[0];
  const trial = state.trials.trials.filter(t => t._id === (participant && participant.trial))[0];
  return { participant, trial };
};
const mapDispatchToProps = dispatch => ({
  onStageCompleted: (id, stage) => dispatch(actions.participants.completeStage(id, stage)),
});

const ParticipateStageContainer = withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ParticipateStage)));

export default ParticipateStageContainer;
